<p class="alert alert-success" *ngIf="successMsg!=undefined"><i class="fa fa-check icon-font">&nbsp;{{successMsg}}</i></p>
<p class="alert alert-danger" *ngIf="errMsg!=undefined"><i class="fa fa-exclamation-triangle icon-font">&nbsp;{{errMsg}}</i></p>

